import React from 'react';

import { bemCssModules, getFormattedFiatCurrencyNumber } from '@utils';

import { TCircle } from '@containers/BalanceChart/types';

import style from './Caption.scss';

const cn = bemCssModules(style, 'Caption');

export type TCaption = {
  circle: TCircle;
  onlyCurrencyForMobile?: boolean;
};

export const Caption: CustomFC<TCaption> = props => {
  const { circle, onlyCurrencyForMobile = false, className } = props;
  const balance = getFormattedFiatCurrencyNumber({
    amount: circle.balance,
    currency: circle.fiatCurrency,
  });

  const color =
    circle.color === '--color-main-border' ? '--color-main-secondary-text' : circle.color;

  return (
    <li className={cn(null, [className])}>
      <span className={cn('percent')} style={{ color: `var(${color})` }}>
        <i className={cn('dot')} />
        {circle.percent.toFixed(0)}%
      </span>
      {circle.label}
      <span className={cn('divider', { onlyCurrencyForMobile })}>·</span>
      <span className={cn('balance', { onlyCurrencyForMobile })}>{balance}</span>
    </li>
  );
};

export default Caption;
